import type { BookingStatus, VehicleStatus } from '@aldorock-fordon/shared/api-types';
import { sv } from '@aldorock-fordon/shared/sv';

export type Tone = 'active' | 'done' | 'waiting' | 'late' | 'none';

/** A square marker and a word: colour never carries the meaning alone. */
export function Status({ tone, children }: { tone: Tone; children: string }) {
  return (
    <span className="status" data-state={tone}>
      {children}
    </span>
  );
}

const bookingTone: Record<BookingStatus, Tone> = {
  bokad: 'active',
  pagaende: 'waiting',
  avslutad: 'done',
  makulerad: 'none',
};

export function BookingStatusView({ status }: { status: BookingStatus }) {
  return <Status tone={bookingTone[status]}>{sv.bookingStatus[status]}</Status>;
}

const vehicleTone: Record<VehicleStatus, Tone> = {
  bestalld: 'waiting',
  aktiv: 'done',
  avstalld: 'none',
  avyttrad: 'none',
};

export function VehicleStatusView({ status }: { status: VehicleStatus }) {
  return <Status tone={vehicleTone[status]}>{sv.vehicleStatus[status]}</Status>;
}
